import './../../scss/components/_inline-copy.scss'

const copyText = async (text) => {
    if (!text) {
        return
    }

    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text)

        return
    }

    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'absolute'
    textarea.style.left = '-9999px'
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
}

const setState = (button, state) => {
    if (!button) {
        return
    }

    button.dataset.copyState = state
    window.setTimeout(() => {
        delete button.dataset.copyState
    }, 2000)
}

const handleInlineCopyClick = async (event) => {
    const button = event.target.closest('[data-inline-copy-button]')
    if (!button) {
        return
    }

    const wrapper = button.closest('[data-inline-copy]')
    const target = wrapper ? wrapper.querySelector('.inline-copy__target') : null
    let value = ''

    if (target) {
        value = target.textContent.trim()
    }

    if (!value) {
        return
    }

    try {
        await copyText(value)
        setState(button, 'success')
    } catch (error) {
        setState(button, 'error')
    }
}

document.addEventListener('click', handleInlineCopyClick)
